import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/homepage/image-3.png")